import { PiIconProps } from "./Icons";

export default function PiUnityIcon(props: PiIconProps) {
  const { width, height, className } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 85.6 96.6"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
    >
      <path
        d="M46.5,17.3l15.3,8.8c0.6,0.3,0.6,1.2,0,1.5L43.6,38.1c-0.6,0.3-1.2,0.3-1.7,0L23.8,27.6c-0.6-0.3-0.6-1.2,0-1.5L39,17.3V0
      L0,22.5v45.1v-0.2v0.2L15,59V41.3c0-0.6,0.7-1.1,1.3-0.7l18.2,10.5c0.6,0.3,0.9,0.9,0.9,1.5v21c0,0.6-0.7,1.1-1.3,0.7l-15.3-8.8
      l-15,8.6l39,22.5l39-22.5l-15-8.6l-15.3,8.8c-0.5,0.3-1.3-0.1-1.3-0.7v-21c0-0.6,0.3-1.2,0.9-1.5l18.2-10.5
      c0.5-0.3,1.3,0.1,1.3,0.7V59l15,8.6V22.5L46.5,0V17.3z"
      />
    </svg>
  );
}
